import { useNavigationContext } from '../../../contexts/NavigationContext';
import PropertyPage from './properties/PropertyPage';

import NewsPage from '../news/NewsPage';
import { CONSTANT } from '../../../utils/constants';
import MainLayout from '../../../components/Display/MainLayout';

import './DiardExpertise.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout enableAnalytics={false} scope={'diardexpertise'} websiteLabel={"diard-expertise.fr"}>
      <NewsPage
        isActive={navigationContext.activeAppKey === 'news'}
        scope={'diardexpertise'}
        tagsType={'def_keywords'}
        typeList={CONSTANT.diardexpertise.availableNewsTypes}
      />
      <PropertyPage isActive={navigationContext.activeAppKey === 'defproperty'} />

    </MainLayout>
  );
}

export default Home;
